var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRadioSelected(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.0835 3.5C4.4275 3.5 3.0835 4.844 3.0835 6.5C3.0835 8.156 4.4275 9.5 6.0835 9.5C7.7395 9.5 9.0835 8.156 9.0835 6.5C9.0835 4.844 7.7395 3.5 6.0835 3.5ZM6.0835 0.5C2.7685 0.5 0.0834961 3.185 0.0834961 6.5C0.0834961 9.815 2.7685 12.5 6.0835 12.5C9.3985 12.5 12.0835 9.815 12.0835 6.5C12.0835 3.185 9.3985 0.5 6.0835 0.5ZM6.0835 11.3C3.4315 11.3 1.2835 9.152 1.2835 6.5C1.2835 3.848 3.4315 1.7 6.0835 1.7C8.7355 1.7 10.8835 3.848 10.8835 6.5C10.8835 9.152 8.7355 11.3 6.0835 11.3Z",
    fill: "#2F2137"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRadioSelected);
export default __webpack_public_path__ + "static/media/radio_selected.e7b2491cd21f19ac41043dca281a5e3f.svg";
export { ForwardRef as ReactComponent };